import { Town } from '@dreryk/address-common-api';

import { BindingCreator } from '@dreryk/react-common';
import { TownInput } from '@dreryk/react-components';

const TOWN_FIELD_NAME = 'town';
const TOWN_FIELD_MAX_LENGTH = 50;

export type TownFormBeanPart = {
   [TOWN_FIELD_NAME]: Town | null;
};

type TownFieldProps = {
   readonly register: BindingCreator<TownFormBeanPart, typeof TOWN_FIELD_NAME>;
};

export const TownField = (props: TownFieldProps): JSX.Element => {
   return (
      <TownInput
         controller={props.register(TOWN_FIELD_NAME, {
            required: true,
            /*
             * TODO: DREGAB-19275 - Poprawa walidacji tak by populowała walidacje z wnętrza komponentu
             * react-components i nie trzeba było ich powtarzać ponownie podczas rejestracji pola
             */
            maxLength: TOWN_FIELD_MAX_LENGTH,
         })}
         testId={TOWN_FIELD_NAME}
      />
   );
};
